import { ReactNode } from "react";
import { CustomState } from "../../../Hooks/State.hook";
import StyledReports from "./style";
import Select, { Option } from "../../../components/Select";
import cssVars from "../../../styles/cssVariables.vars";
import AttendancesWithoutResponse from "./AttendancesWithoutResponse";
import MessagesByUser from "./MessagesByUser";
import MessagesByContact from "./MessagesByContact";
import MessagesByHourAndDay from "./MessagesByHourAndDay";
import { currentRoute } from "../../../contexts/global/LoginContext";

function Reports() {
    const options: Array<Option<ReactNode>> = [
        { name: "Atendimentos sem resposta", value: <AttendancesWithoutResponse />, key: "attendancesWithoutResponse" },
        { name: "Mensagens por contato", value: <MessagesByContact />, key: "messagesByContact" },
        { name: "Mensagens por usuário", value: <MessagesByUser />, key: "messagesByUser" },
        { name: "Mensagens por dia/hora", value: <MessagesByHourAndDay />, key: "messagesByHourAndDay" },
    ];

    if (currentRoute === "natrielli" || currentRoute === "develop") {
        options.push(
            { name: "Pesquisa de contato", value: <iframe src="https://contec.inf.br/natrielli/reports/contact-research" style={{ width: "100%", height: "100%" }} />, key: "contactResearch" },
            { name: "Pesquisa de satisfação", value: <iframe src="https://contec.inf.br/natrielli/reports/satisfaction-research" style={{ width: "100%", height: "100%" }} />, key: "satisfactionResearch" }
        );
    }

    const selectedOption = CustomState<ReactNode>(null);

    return (
        <StyledReports>
            <header>
                <Select<ReactNode>
                    $fontSize={1}
                    $padding={[0.5, 1]}
                    options={options}
                    onChange={(v) => selectedOption.set(v)}
                    placeholder="Selecione um relatório para exibir"
                    $color={cssVars.colorGrey[4]}
                    $focusColor={cssVars.colorGrey[2]}
                    $width="30rem"
                />
            </header>
            <main>
                {selectedOption.value}
            </main>
        </StyledReports>
    );
};

export default Reports;